function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.313 11.687c.948.947 2.15 1.593 3.768 2.181-1.617.588-2.82 1.234-3.768 2.181-.947.948-1.593 2.15-2.181 3.768-.588-1.617-1.234-2.82-2.181-3.768-.948-.947-2.15-1.593-3.768-2.181 1.617-.588 2.82-1.234 3.768-2.181.947-.948 1.593-2.15 2.181-3.768.588 1.617 1.234 2.82 2.181 3.768z",
  stroke: "inherit",
  strokeWidth: "inherit"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.434 10.027c-.257-.607-.553-1.097-.958-1.502-.405-.405-.895-.702-1.502-.958.606-.257 1.096-.554 1.5-.959.406-.405.703-.894.96-1.502.256.607.553 1.097.958 1.502.405.405.895.702 1.502.958-.607.257-1.097.554-1.502.958-.405.405-.701.895-.958 1.503z",
  stroke: "inherit"
});

function SvgProductCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 2 18 21"
  }, props), _ref, _ref2);
}

export default SvgProductCollection;